import { useTranslation } from 'react-i18next'
import { LANGUAGE_STORAGE_KEY } from 'src/i18n/config'
import { SegmentedControl } from 'src/components/segmented-control'
import { FaGlobe } from 'react-icons/fa'

type Language = 'en' | 'es'

export const LanguageSwitcher = ({ isCollapsed }: { isCollapsed?: boolean }) => {
  const { t, i18n } = useTranslation()
  const currentLang = i18n.language

  const switchLanguage = (lang: string) => {
    if (lang === currentLang) return
    i18n.changeLanguage(lang)
    localStorage.setItem(LANGUAGE_STORAGE_KEY, lang)
  }

  const toggleLanguage = () => {
    switchLanguage(currentLang === 'en' ? 'es' : 'en')
  }

  if (isCollapsed) {
    return (
      <button
        onClick={toggleLanguage}
        className="flex h-12 w-12 flex-col items-center justify-center rounded-lg text-xs font-semibold text-text-secondary transition-colors hover:bg-surface-hover"
        title={currentLang === 'en' ? t('language.switchToSpanish') : t('language.switchToEnglish')}
        aria-label={
          currentLang === 'en' ? t('language.switchToSpanish') : t('language.switchToEnglish')
        }
      >
        <FaGlobe className="h-6 w-6" />
        <span className="mt-0.5 text-[10px] uppercase">{currentLang}</span>
      </button>
    )
  }

  return (
    <SegmentedControl<Language>
      aria-label={t('language.switcherLabel')}
      size="sm"
      value={currentLang === 'es' ? 'es' : 'en'}
      onChange={switchLanguage}
      data-testid="language-switcher"
      options={[
        { value: 'en', label: t('language.en'), 'data-testid': 'language-en' },
        { value: 'es', label: t('language.es'), 'data-testid': 'language-es' },
      ]}
    />
  )
}
